import Backbone from 'backbone';


export const Contact = Backbone.Model.extend({
  defaults: {
    first_name: '',
    last_name: '',
    school_class: '',
    school_reg: '',
    school_year: '',
    groups: ''
  },

  displayGroupList() {
    const schoolClass = this._listForm(this.get('school_class'));
    const schoolReg = this._listForm(this.get('school_reg'));
    const schoolYear = this._listForm(this.get('school_year'));
    const groups = this.get('groups');

    return `${schoolClass}${schoolReg}${schoolYear}${groups}`;
  },

  giftAid() {
    return this.get('gift_aid') ? 'G' : '';
  },

  joinos() {
    return this.get('has_joinos') ? 'J' : '';
  },

  _listForm: (strval) => strval ? `${strval}, ` : ''
});



// WEBPACK FOOTER //
// ./base/models/contact.js